import { createDmScansService, type DmScansQueryConfig } from '@odo/shared-ui';
import apiV2 from '../api/v2';
import Locals from '../providers/Locals';
import { toDmError } from './dmErrors';

// In dev the FE runs on a different origin than the backend, so relative
// `/api/v2/...` photo paths need the base URL prefix to reach it.
const API_BASE_URL = Locals.config().base_api_url;

export const dmScansService = createDmScansService({
    api: apiV2,
    apiBaseUrl: API_BASE_URL,
    mapError: toDmError
});

export const dmScansQueryConfig: DmScansQueryConfig = {
    service: dmScansService,
    queryKeyRoot: 'v2/patients'
};

export const { fetchDmScans, fetchDmScanDetail, fetchMorphing } = dmScansService;

export type {
    ClassGrade,
    DmScanDetail,
    DmScanInstruction,
    DmScanMeasurements,
    DmScanObservation,
    DmScanPhoto,
    DmScanSummary,
    DmSidedClass,
    Morphing
} from '@odo/shared-ui';
